import Tippy from '@tippyjs/react';
import classnames from 'classnames';
import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { useGame } from '../../../context';
import { toggleFilter } from '../../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&.hidden': { opacity: 0.25 },
    '&:hover': { opacity: 0.65 },
    composes: ['is-relative', 'mb6', 'mr6'],
    height: 28,
    opacity: 1,
    transition: 'opacity 0.3s',
    width: 28,
  },
  categories: {
    composes: ['flex-columns', 'flex-wrap', 'flex-start', 'margin-auto'],
    maxWidth: 170,
    minWidth: 170,
    width: 170,
  },
  tooltip: {
    background: '#202124',
    color: '#919191',
  },
  wrapper: {
    composes: ['is-absolute'],
    left: 0,
    top: 0,
  },
});

const sortByOrder = (a, b) => {
  if (a.order > b.order) return 1;
  if (a.order < b.order) return -1;
  return 0;
};

const CategoryButtonComponent = React.memo(() => {
  const classes = useStyles();
  const { icons } = useGame();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);

  const clickHandler = useCallback(
    (type, visible) => dispatch(toggleFilter([type], visible)),
    [dispatch]
  );

  return (
    <div className={classes.categories}>
      {Object.values(icons)
        .sort(sortByOrder)
        .map(data => {
          const { Icon, color, id, label } = data;
          const hidden = filters.includes(id);
          return (
            <Tippy
              arrow={false}
              className={classes.tooltip}
              content={label}
              placement="top">
              <button
                key={id}
                className={classnames(classes.button, { hidden })}
                type="button"
                onClick={() => clickHandler(id, !hidden)}>
                <div className={classes.wrapper}>
                  <Icon
                    background={color}
                    style={{ marginLeft: 0, marginTop: 0 }}
                  />
                </div>
              </button>
            </Tippy>
          );
        })}
    </div>
  );
});

CategoryButtonComponent.displayName = 'CategoryButtonComponent';

export default CategoryButtonComponent;
